import React from 'react';
import { WorkScheduleService } from '../../../services/Works';
import { CommonHistoryDropdown } from './CommonHistoryDropdown';

export class WorkContentsHistoryDropdown extends React.Component {
  /**
   * 履歴取得
   */
  getHistories = async fieldId => {
    if (
      !this.props.fieldTreeId ||
      !this.props.jobId ||
      !this.props.foremanUserId
    ) {
      return null;
    }

    const params = {
      field_id: fieldId,
      foreman_user_id: this.props.foremanUserId,
      column: 'contents',
    };

    return WorkScheduleService.histories(fieldId, params).then(response => {
      if (response.result) {
        return response.data.entities.works;
      } else {
        return null;
      }
    });
  };

  render() {
    return (
      <CommonHistoryDropdown
        {...this.props}
        isTextArea={true}
        maxLength={255}
        getHistories={this.getHistories}
        column={'contents'}
        resetKeys={[
          this.props.fieldTreeId,
          this.props.jobId,
          this.props.foremanUserId,
        ]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/WorkContentsHistory.jsx